import { usePlanningTranslation } from '@libs/utils/translations'
import React from 'react'
import type { FC } from 'react'
import type { ModulationSchema } from 'snap-redux/infra/http/routesConfig'

import type { HourFormattingFunct } from './ModulationCounters'

type ModulationCounterPopoverContentProps = {
  modulationCounters: ModulationSchema
  displayInHoursAndMinutes: HourFormattingFunct
  displayInHoursAndMinutesWithSign: HourFormattingFunct
}

export const ModulationCounterPopoverContent: FC<
  ModulationCounterPopoverContentProps
> = ({
  modulationCounters,
  displayInHoursAndMinutes,
  displayInHoursAndMinutesWithSign
}) => {
  const { t } = usePlanningTranslation()

  const counterLines = [
    t('weekly.team.row.employeeCounters.modulationCounterPopover.bowBalance', {
      hoursAndMinutes: displayInHoursAndMinutesWithSign(
        modulationCounters.beginning_of_week_balance
      )
    }),
    modulationCounters.mode === 'legal'
      ? t(
          'weekly.team.row.employeeCounters.modulationCounterPopover.weeklyTarget',
          {
            hoursAndMinutes: displayInHoursAndMinutes(
              modulationCounters.weekly_target
            )
          }
        )
      : null,
    t('weekly.team.row.employeeCounters.modulationCounterPopover.contributed', {
      hoursAndMinutes: displayInHoursAndMinutes(modulationCounters.contributed)
    }),
    t('weekly.team.row.employeeCounters.modulationCounterPopover.eowBalance', {
      hoursAndMinutes: displayInHoursAndMinutesWithSign(
        modulationCounters.end_of_week_balance
      )
    }),
    t(
      modulationCounters.mode === 'legal'
        ? 'weekly.team.row.employeeCounters.modulationCounterPopover.counterOnPeriodLegal'
        : 'weekly.team.row.employeeCounters.modulationCounterPopover.counterOnPeriodSmoothing',
      {
        eowContributedHoursAndMinutes: displayInHoursAndMinutes(
          modulationCounters.end_of_week_contributed
        ),
        periodTargetHoursAndMinutes: displayInHoursAndMinutes(
          modulationCounters.period_target
        )
      }
    )
  ]

  return (
    <ul>
      {counterLines
        .filter(line => line)
        .map((counterLine, index) => (
          <li key={index}>{counterLine}</li>
        ))}
    </ul>
  )
}
